var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAnnounement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6543 6.08594L9.6543 19.695C9.6543 19.8398 9.61853 19.9825 9.55017 20.1102C9.48181 20.2379 9.38297 20.3468 9.26243 20.4272L8.0533 21.2333C7.93597 21.3115 7.80155 21.3604 7.66138 21.3758C7.5212 21.3912 7.37937 21.3727 7.24784 21.3219C7.11631 21.271 6.99892 21.1893 6.90557 21.0836C6.81222 20.9779 6.74564 20.8513 6.71144 20.7145L5.2543 14.8859",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25449 14.8859C4.08754 14.8859 2.96838 14.4223 2.14322 13.5971C1.31806 12.772 0.854492 11.6528 0.854492 10.4859C0.854492 9.3189 1.31806 8.19974 2.14322 7.37458C2.96838 6.54942 4.08754 6.08585 5.25449 6.08585L9.65449 6.08585C9.65449 6.08585 15.6442 6.08585 21.4081 1.25161C21.5363 1.14372 21.6926 1.07467 21.8587 1.05259C22.0248 1.03052 22.1938 1.05632 22.3457 1.12698C22.4976 1.19764 22.6262 1.31021 22.7163 1.45145C22.8065 1.59269 22.8544 1.75674 22.8545 1.92429L22.8545 19.0474C22.8544 19.215 22.8065 19.379 22.7163 19.5203C22.6262 19.6615 22.4976 19.7741 22.3457 19.8447C22.1938 19.9154 22.0248 19.9412 21.8587 19.9191C21.6926 19.897 21.5363 19.828 21.4081 19.7201C15.6442 14.8859 9.65449 14.8859 9.65449 14.8859H5.25449Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAnnounement);
export default __webpack_public_path__ + "static/media/email-announement.d86eaaef806b3e0df45c91d179a90a37.svg";
export { ForwardRef as ReactComponent };